import React, { memo, useCallback, useContext, useMemo, useState } from "react";
import { faBan, faCheck, faEdit, faPen, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { celularMask } from "../../../../../components/InputTextMask";
import { MeioComunicacaoContext } from "../../../../../contexts/MeioComunicacaoContext";
import caAPI from "../../../../../services/caAPI";
import { successToast } from "../../../../../components/DommusToast";
import Swal from "sweetalert2";
import "./index.scss";

export const LinhaContato = memo(({contato, idMeio, slugMeio, listaAgentesAtivos})=>{
  const methods = useForm({defaultValues: {descricao: contato?.descricao}})
  const {setMeiosComunicacao, setContatoOrigemSelecionado} = useContext(MeioComunicacaoContext);

  const nomeAgenteIa = useMemo(() => {
    if (contato?.id_agente_ia == null) return 'Nenhum';

    const agenteAtivo = listaAgentesAtivos.find((agente) => Number(agente.id_agente_ia) === Number(contato.id_agente_ia));
    if (agenteAtivo) return agenteAtivo.nome;

    return `${contato?.agente_ia?.nome || 'Agente de IA'} (inativo)`;
  }, [contato, listaAgentesAtivos]);

  const handleOnSubmit = (data) => {
    if(contato.descricao.trim() !== data?.descricao.trim()) {
      methods.setFocus('descricao', { shouldSelect: false });
      document.activeElement?.blur();
      const payload = {
        descricao: data?.descricao?.trim(),
      }
      handleAlterarContato(payload);
    }
  }

  const handleAlterarContato = useCallback(function (data) {
    caAPI.contato_origem.update(contato?.id_contato_origem, data).then(res => {
      setMeiosComunicacao((current) => {
        return current.map((meioComunicacao) => {
          if(Number(meioComunicacao.id) === Number(idMeio)) {
            meioComunicacao.contatos_origem = meioComunicacao.contatos_origem.map((contatoOrigem) => {
              if(Number(contatoOrigem.id_contato_origem) === Number(contato.id_contato_origem)) {
                return {...res.data};
              }
              return contatoOrigem;
            })
          }
          return meioComunicacao;
        })
      })
      successToast.fire('Descrição Atualizada!');
    }).catch(err => {
      Swal.fire({
        titleText: "Erro",
        text: "Houve um problema ao atualizar dados do contato ",
        icon: 'error'
      });
    })
  }, [setMeiosComunicacao, contato]);
  
  const contatoValor = useMemo(()=>{
    switch(slugMeio) {
      case 'whatsapp':
      case 'voip':
        return celularMask(contato.valor);
      default:
        return contato.valor;
    }
  },[contato, slugMeio])

  return (
    <tr>
      <td className="item-descricao">
        <Form onSubmit={methods.handleSubmit(handleOnSubmit)} className="form-ramal">
          <Form.Control 
            type="text" 
            {...methods.register('descricao', {required: true})}
          />
          <div className="btns-actions">
            <Button variant="secondary" type="submit" className="btn-action btn-submit"><FontAwesomeIcon icon={faCheck}/></Button>
            <Button variant="secondary" className="btn-action btn-cancel" onClick={()=>{methods.reset({descricao: contato.descricao})}}><FontAwesomeIcon icon={faBan}/></Button>
          </div>
        </Form>
      </td>
      <td>{contatoValor}</td>
      {slugMeio === 'whatsapp' && <td>{nomeAgenteIa}</td>}
      <td className="text-center">
        <Dropdown>
          <Dropdown.Toggle variant="primary">
              <FontAwesomeIcon icon={faPen} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
              <Dropdown.Item
                  as="button"
                  onClick={() => {
                    setContatoOrigemSelecionado(contato)
                  }}
              >
                <FontAwesomeIcon
                    icon={faEdit}
                    color="#B5DEFF"
                    style={{ marginRight: 10 }}
                />
                Editar
              </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  )
}); 
